import { Action } from '@ngrx/store';
import { environment } from 'projects/semeris/src/environments/environment';

// replaced based on environment
export let measureReducer: typeof measureReducerReal;
if (environment.envId === 'dev') {
  measureReducer = measureReducerReal;
} else {
  measureReducer = measureReducerNoop;
}

// stats map
interface ReducerStats {
  count: number;
  totalTime: number;
  average?: number;
}
const reducerStatsMap = new Map<string, ReducerStats>();

function measureReducerReal<T>(
  reducer: (state: T | undefined, action: Action) => T
): (state: T | undefined, action: Action) => T {
  return (state: T | undefined, action: Action): T => {
    const before = performance.now();
    const nextState = reducer(state, action);
    const elapsedTime = performance.now() - before;

    const stats = reducerStatsMap.get(action.type) || { count: 0, totalTime: 0 };
    stats.count += 1;
    stats.totalTime += elapsedTime;
    reducerStatsMap.set(action.type, stats);

    return nextState;
  };
}

// noop for production
function measureReducerNoop<T>(
  reducer: (state: T | undefined, action: Action) => T
): (state: T | undefined, action: Action) => T {
  return reducer;
}

// table print
export function printReducerStatsTable(includes?: string) {
  const map = includes
    ? new Map([...reducerStatsMap].filter(([k]) => k.includes(includes)))
    : reducerStatsMap;

  const data = Object.fromEntries([...map].sort(([, a], [, b]) => b.totalTime - a.totalTime));
  Object.values(data).forEach((stat) => (stat.average = stat.totalTime / stat.count));

  console.table(data);
}
